import store from "../store";
import _ from "lodash";

import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.login = (credentials) => {
  return http
    .post("/login/common", credentials)
    .then((response) => {
    
      store.dispatch("auth/setAuth", response.data);
    })
    .catch((error) => {
      console.error("authService.login-error:\n", error);
      throw error;
    });
};

internals.changePassword = (credentials) => {
  return http
    .put("/update-user-pass", credentials)
    .then((response) => {
    
      store.dispatch("auth/setAuth", response.data);
    })
    .catch((error) => {
      console.error("authService.login-error:\n", error);
      throw error;
    });
};

internals.loginAzure = (credentials) => {
  return http
    .post("/auth/azure", credentials)
    .then((response) => {
    
      store.dispatch("auth/setAuth", response);
    })
    .catch((error) => {
      console.error("authService.login-error:\n", error);
      throw error;
    });
};

internals.logout = () => {
  store.dispatch("auth/useRefreshToken");
  return http
    .delete("/logout")
    .then((response) => {
      store.dispatch("auth/clearAuth");
    })
    .catch((error) => {
      console.error("authService.logout-error:\n", error);
      throw error;
    });
};

internals.registerUser = (user) => {
  return http
    .post("/register", { user, registerType: "Register" })
    .catch((error) => {
      console.error("authService.registerUser-error:\n", error);
      throw error;
    });
};

internals.updateUser = (user) => {
  user = Object.assign({}, user);
  delete user.createdAt;
  delete user.createdAt;
  delete user.isDeleted;
  delete user.isEnabled;
  delete user.profileImageUrl;
  delete user.updatedAt;
  delete user.isPinChanged;
  // delete user.mobile;
  delete user.licenceNumber;
  delete user.isPinChanged;
  return http
    .put("/updateuser", {
      user,
      registerType: "Invite",
    })
    .then((result) => {
      user = result.data;

      return user;
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.updateUserStatus = (user) => {
  user = Object.assign({}, user);

  delete user.createdAt;

  delete user.createdAt;

  delete user.isDeleted;

  delete user.isEnabled;

  delete user.profileImageUrl;

  delete user.updatedAt;



  return http
    .put("/updateuser", {
      user,
      registerType: "Invite",
    })
    .then((result) => {
      user = result.data;

      return user;
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

// internals.getUser = userId => {
//   return http
internals.getUser = (userId) => {
  return http
    .get("/user/" + userId +"?%24embed=cityId,role")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("authService.getUser-error:\n", error);
      throw error;
    });
};

internals.userSearch = function(params, searchItem) {
  return http
    .get(
      `/datacity/search?page=${params.page}&limit=${params.limit}&searchString=${searchItem}`
    )
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.addUser = (user) => {
  user = Object.assign({}, user);

  const promises = [];
  return http
    .post("/register", {
      user,
      registerType: "Register",
    })
    .then((result) => {
      user = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.sendActivationEmail = (email) => {
  return http
    .post("/register/send-activation-email", { email })
    .catch((error) => {
      console.error("authService.sendActivationEmail-error:\n", error);
      throw error;
    });
};

internals.updateUserPassword = (user) => {
  //   password = Object.assign({}, user);
  const promises = [];
  return http
    .post("/resetPassword/admin", {
      email: user.email,
      password: user.password,
      confirmPassword: user.confirmPassword,
    })
    .then((result) => {
      user = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("user.create-error:\n", error);
      throw error;
    });
};

internals.resetPasswords = (password,token) => {
  return http.post("/forgot-pass-callback", { password,token }).catch((error) => {
    console.error("authService.resetPassword-error:\n", error);
    throw error;
  });
};

internals.resetPasswordAdmin = (email,password,confirmPassword) => {
  return http.post("/resetPassword/admin", { email,password,confirmPassword }).catch((error) => {
    console.error("authService.resetPassword-error:\n", error);
    throw error;
  });
};

internals.sendResetLink = (email) => {
  return http.post("/login/forgot", { email }).catch((error) => {
    console.error("authService.sendResetLink-error:\n", error);
    throw error;
  });
};

internals.resetPassword = (token, password) => {

  return http.post("/login/reset", { token, password }).catch((error) => {
    console.error("authService.resetPassword-error:\n", error);
    throw error;
  });
};

internals.activateAccount = (token) => {
  return http.post("/register/activate", { token }).catch((error) => {
    console.error("authService.activateAccount-error:\n", error);
    throw error;
  });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/auth.service.js